import ApisMethods from './apisMethods'
import {factoryNameToPaySlug, toIsoCurrencyCode} from '../utils/paymentHelpers'

const Temps = {
  getCategories: (callBack: any, setIsLoading: any) => {
    ApisMethods().get(`/vendor/templates/template-categories`, callBack, setIsLoading)
  },
  getTemplates: (id: any, callBack: any, setIsLoading: any) => {
    ApisMethods().get(
      `/vendor/templates/template-categories/${id}/templates`,
      callBack,
      setIsLoading
    )
  },

  /**
   * Free template → applies immediately.
   * Paid template → starts platform OTP (returns signature, amount, currency).
   */
  change: (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(`/vendor/templates/change-template`, data, callback, setIsLoading)
  },

  /** Verify platform OTP (code + signature). Does not charge gateway. */
  confirmOtp: (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(`/vendor/templates/confirm-otp`, data, callback, setIsLoading)
  },

  resendOtp: (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(`/vendor/common/resend-code`, data, callback, setIsLoading)
  },

  /** POST /vendor/templates/pay-{whish|blom|omt} */
  payByGateway: (factoryName: string, data: any, callback: any, setIsLoading: any) => {
    const slug = factoryNameToPaySlug(factoryName)
    const payload = {
      ...(data || {}),
      currency_code: toIsoCurrencyCode(data?.currency_code),
    }
    ApisMethods().post(`/vendor/templates/pay-${slug}`, payload, callback, setIsLoading)
  },
}
export default Temps
